import { useEffect } from 'react';
import {
	resolveAdCreativeType,
} from '../../data/acOrderRules';
import InputComponent from '../../components/InputComponent';

// SCSS
import '../../assets/scss/sectionFour.scss';
import '../../assets/scss/checkboxComponent.scss';

const SectionFour = ({ register, formData, setValue }) => {
	const adCreativeType =
		formData.adCreativeType || resolveAdCreativeType(formData);

	useEffect(() => {
		if (adCreativeType === 'animatedAd') {
			setValue('stillbildevideo-slide1', '', { shouldDirty: true });
			setValue('stillbildevideo-slide2', '', { shouldDirty: true });
			setValue('stillbildevideo-slide3', '', { shouldDirty: true });
		}
	}, [adCreativeType, setValue]);

	return (
		<div className='sectionFour'>
			<div className='imageVideoAd flex-col'>
				<div className='content'>
					<h2>Animert annonse eller stillbildevideo?</h2>
					<div className='border'></div>
				</div>
				<div className='flex-row checkboxes' role='radiogroup' aria-label='Annonseformat'>
					<div className='checkbox-container stillbildevideo'>
						<input
							type='radio'
							id='adCreativeType-stillbildevideo'
							value='stillbildevideo'
							className='checkbox-card-input'
							{...register('adCreativeType', {
								required:
									'Velg stillbildevideo eller animert annonse',
							})}
						/>
						<label
							htmlFor='adCreativeType-stillbildevideo'
							className='checkbox-card-label'
						>
							Stillbildevideo
						</label>
					</div>
					<div className='checkbox-container animatedAd'>
						<input
							type='radio'
							id='adCreativeType-animatedAd'
							value='animatedAd'
							className='checkbox-card-input'
							{...register('adCreativeType', {
								required:
									'Velg stillbildevideo eller animert annonse',
							})}
						/>
						<label
							htmlFor='adCreativeType-animatedAd'
							className='checkbox-card-label'
						>
							Animert annonse
						</label>
					</div>
				</div>
				<div className='flex-row vidExamples'>
					<small>
						Eksempel stillbildevideo{' '}
						<a
							target='_blank'
							href='https://content.jwplatform.com/videos/HiEccThq-Ni6csKfy.mp4'
							rel='noreferrer'
						>
							Eksempel stillbildevideo
						</a>
					</small>

					<small>
						Eksempel animert annonse{' '}
						<a
							target='_blank'
							href='https://content.jwplatform.com/videos/YJA6F6w0-Ni6csKfy.mp4'
							rel='noreferrer'
						>
							Eksempel animert
						</a>
					</small>
				</div>

				{adCreativeType === 'stillbildevideo' && (
					<div className='stillSlides flex-col'>
						<h3 className='mt-4'>
							Ved stillbildevideo, skriv inn tekst til video her.
							Maks en setning per "slide" - totalt 3 slides. Jo
							mindre tekst, jo bedre
						</h3>

						<div className='flex-col'>
							<InputComponent
								type='text'
								name='stillbildevideo-slide1'
								register={register}
								className='slides'
								placeholder='Slide 1...'
							/>
							<InputComponent
								type='text'
								name='stillbildevideo-slide2'
								register={register}
								className='slides'
								placeholder='Slide 2...'
							/>
							<InputComponent
								type='text'
								name='stillbildevideo-slide3'
								register={register}
								className='slides'
								placeholder='Slide 3...'
							/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default SectionFour;
